import { render, staticRenderFns } from "./VTableProPatientVersus.vue?vue&type=template&id=14d0de54"
import script from "./VTableProPatientVersus.vue?vue&type=script&lang=js"
export * from "./VTableProPatientVersus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports